export const MBENotificationLetterTypes = {
  MBENotification: 0,
  CEPTransferNotification: 1,
};

export const MBENotificationLetterHistoryTypes = {
  MBENotification: 'M',
  CEPTransferNotification: 'C',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/MBENotificationLetterTypes.js